const stringToClassName = str => {
  if (!str) {
    return '';
  }
  return (
    str
      .trim()
      // remove illegal characters
      .replace(/[^\w\s$*_+~.()'"!\-:@]/g, '')
      // convert spaces
      .replace(/[-\s]+/g, '-')
      // convert case
      .toLowerCase()
  );
};

export default stringToClassName;
